import ApiService from './ApiService'

const endpoint = '/appointment-preferences'

export async function apiGetAppointmentPreferences() {
    return ApiService.fetchData({
        url: endpoint,
        method: 'get',
    })
}

export async function apiUpdateAppointmentPreferences(data) {
    return ApiService.fetchData({
        url: endpoint,
        method: 'patch',
        data,
    })
}
